import * as React from 'react'
function SvgHeartEmpty(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M33.364 8.636A8.971 8.971 0 0027 6a8.755 8.755 0 00-7 3.414A8.767 8.767 0 0013 6a9 9 0 00-6.364 15.364l11.99 11.337a2 2 0 002.748 0l11.99-11.337a9 9 0 000-12.728zM20 28.494l-10.57-10A5 5 0 0113 10c2.874 0 4.624 1.362 7 5.25 2.374-3.888 4.124-5.25 7-5.25a5 5 0 013.57 8.502L20 28.494z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgHeartEmpty
